var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 54,
    viewBox: "0 0 228 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WARNING!",
    filter: "url(#filter0_d_2_852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M207.286 25.9415L207.299 26.4287H207.786H215.983H216.467L216.482 25.945L217.274 1.58154L217.291 1.06531H216.774H207.164H206.651L206.664 1.57806L207.286 25.9415ZM207.898 29.1235C206.968 29.9682 206.551 31.239 206.551 32.8251C206.551 34.4055 206.994 35.6783 207.961 36.5464C208.918 37.4053 210.303 37.7908 212.026 37.7908C213.746 37.7908 215.129 37.416 216.086 36.5789C217.055 35.7307 217.5 34.4847 217.5 32.9382C217.5 31.2857 217.088 29.9724 216.153 29.1235C215.227 28.2447 213.812 27.8594 212.026 27.8594C210.239 27.8594 208.824 28.2447 207.898 29.1235Z",
    fill: "#58FFF5",
    stroke: "#73A18E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M196.814 12.5015L197.358 12.6661L197.451 12.1046L198.978 2.89059L199.042 2.50313L198.681 2.349C195.778 1.1104 192.335 0.5 188.366 0.5C183.355 0.5 179.683 2.12632 177.491 5.47328C175.341 8.71807 174.299 13.3726 174.299 19.3715C174.299 25.365 175.287 29.9473 177.336 33.0444C179.408 36.1777 182.528 37.7342 186.614 37.7342C188.592 37.7342 190.2 37.3287 191.373 36.4522C191.696 36.2254 192.105 35.9109 192.598 35.5116L193.289 36.8926L193.427 37.1689H193.736H200.406H200.906V36.6689V17.28V16.78H200.406H189.61H189.11V17.28V23.9502V24.4502H189.61H191.653V27.8351C190.367 28.0833 189.528 28.1986 189.101 28.1986C188.261 28.1986 187.601 28.0323 187.095 27.7316C186.596 27.4352 186.211 26.9885 185.947 26.3636C185.418 24.9833 185.135 22.7454 185.135 19.5976C185.135 16.4107 185.437 14.1583 186 12.783C186.288 12.1254 186.675 11.6604 187.151 11.356C187.63 11.0501 188.233 10.8836 188.988 10.8836C190.604 10.8836 193.2 11.4098 196.814 12.5015Z",
    fill: "#58FFF5",
    stroke: "#73A18E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M170.841 37.169H171.341V36.669V1.56531V1.06531H170.841H162.192H161.692V1.56531V16.9843L155.249 1.37454L155.122 1.06531H154.787H145.234H144.734V1.56531V36.669V37.169H145.234H153.826H154.326V36.669V21.6662L161.114 36.8728L161.246 37.169H161.57H170.841Z",
    fill: "#58FFF5",
    stroke: "#73A18E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M139.677 37.169H140.177V36.669V1.56531V1.06531H139.677H130.067H129.567V1.56531V36.669V37.169H130.067H139.677Z",
    fill: "#58FFF5",
    stroke: "#73A18E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M124.526 37.169H125.026V36.669V1.56531V1.06531H124.526H115.877H115.377V1.56531V16.9843L108.934 1.37454L108.807 1.06531H108.472H98.9189H98.4189V1.56531V36.669V37.169H98.9189H107.511H108.011V36.669V21.6662L114.799 36.8728L114.931 37.169H115.255H124.526Z",
    fill: "#58FFF5",
    stroke: "#73A18E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M80.983 36.669V24.5068H81.4027L84.8059 36.8024L84.9074 37.169H85.2878H95.7454H96.4268L96.2224 36.519L91.6298 21.9113C92.9071 20.7952 93.8695 19.5479 94.504 18.1671C95.1837 16.6875 95.5106 14.8582 95.5106 12.7013C95.5106 8.75944 94.6134 5.77596 92.7092 3.87041C90.8423 1.96434 87.9334 1.06531 84.1007 1.06531H70.9863H70.4863V1.56531V36.669V37.169H70.9863H80.483H80.983V36.669ZM83.6322 11.3452L83.6365 11.3515L83.641 11.3576C83.9524 11.7822 84.166 12.6715 84.166 14.171C84.166 15.6294 83.9533 16.5019 83.641 16.9278C83.3546 17.3183 82.841 17.5714 81.9527 17.5714H80.983V10.6575H82.0092C82.8395 10.6575 83.3373 10.9163 83.6322 11.3452Z",
    fill: "#58FFF5",
    stroke: "#73A18E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M68.0447 37.169H68.6448L68.5365 36.5787L62.0923 1.47503L62.0171 1.06531H61.6005H47.2425H46.8259L46.7507 1.47503L40.3066 36.5787L40.1982 37.169H40.7983H49.7862H50.1986L50.2771 36.7641L51.2726 31.6293H57.1182L58.1137 36.7641L58.1922 37.169H58.6046H68.0447ZM52.6889 24.0155L54.2802 13.9221L55.8715 24.0155H52.6889Z",
    fill: "#58FFF5",
    stroke: "#73A18E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M39.7322 1.61021L39.7813 1.06531H39.2342H30.3029H29.8295L29.8036 1.53799L28.9085 17.8993L26.615 1.49607L26.5548 1.06531H26.1198H16.6797H16.2395L16.1837 1.50199L14.0734 18.0324L12.769 1.52592L12.7326 1.06531H12.2705H3H2.44493L2.50272 1.61736L6.17701 36.721L6.2239 37.169H6.6743H18.3755H18.8004L18.869 36.7497L21.1696 22.6905L23.9333 36.7653L24.0126 37.169H24.424H36.0687H36.5256L36.5667 36.7139L39.7322 1.61021Z",
    fill: "#58FFF5",
    stroke: "#73A18E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_852",
    x: 0.0896482,
    y: 0,
    width: 227.71,
    height: 53.0908,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.152816 0 0 0 0 0.0287201 0 0 0 0 0.0287201 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_852"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_852",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.29d8147ffeb03eb0f62fabacc88093b5.svg";
export { ForwardRef as ReactComponent };